import { objectToQueryString } from 'site-modules/shared/utils/string';

/**
 * @typedef {object} QueryParameters
 * @property {string} make - Vehicle make name. Case-insensitive. Nice names is allowed. Example: "mercedes-benz".
 * @property {string} model - Vehicle model name. Case-sensitive. Example: "CLA-Class".
 * @property {number} year - Vehicle model year. Year should be in range [2024, 2026]. Example: 2025.
 * @property {number} styleId - Vehicle styleId. Example: 402048729.
 * @property {string} bodyType - Comma-separated list of vehicle body types. Case-insensitive. Nice name is allowed. Example: "SUV,Sedan". Allowed values: "SUV", "Sedan", "Coupe", "Hatchback", "Convertible", "Minivan", "Pickup", "Station Wagon", "Full Size Van".
 * @property {string} engineType - Comma-separated list of vehicle engine types. Case-insensitive. Nice name is allowed. Example: "hybrid,mild hybrid,plug-in hybrid". Allowed values: "diesel", "electric", "hybrid", "mild hybrid", "plug-in hybrid", "gas", "natural gas", "flex-fuel".
 * @property {string} state - State name or code. Case-insensitive. Example: "california".
 * @property {string} zip - Zip code (up to five digits, can start from zero) to calculate distance to the dealer's location. Example: 90404.
 * @property {string} paymentRatio - Payment Ratio (Monthly Payment / MSRP). Range of not negative decimal numbers. Open range is allowed. Example: "0.09-*".
 * @property {string} sortBy - The sorting strategy to sort by field in ascending order. Multiple values should be comma-separated. Case-insensitive. Default: "paymentRatio". Example: "bodyType,paymentRatio". Allowed values: "bodyType", "paymentRatio".
 * @property {number} pageNum - Page number for pagination. Must be >= 1. Default: 1. Example: 3.
 * @property {number} pageSize - Limits the number of items on the page. Range: [1 ... 50]. Default: 20. Example: 10.
 * @property {boolean} distinct - Flag to distinct lease deals to a single Make/Model/Year and Trim with the best(lowest) Payment Ratio based on Make+Model combination. Default: false. Example: true.
 * @property {boolean} debug - Flag to represent if debug will be enabled. Default: false. Example: true.
 */

const BASE_URL = '/purchasefunnel/leasespecials/';

/**
 * Creates the full URL with query parameters.
 *
 * @param {QueryParameters} queryParams - An object containing the query parameters.
 * @returns {string} The complete, encoded URL for the API request.
 */
export const createLeaseSpecialsAPIUrl = queryParams => {
  const queryString = objectToQueryString(queryParams);
  return `${BASE_URL}?${queryString}`;
};
